var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2539 4.6875L12.2839 10.3875C11.9752 10.5809 11.6182 10.6835 11.2539 10.6835C10.8896 10.6835 10.5326 10.5809 10.2239 10.3875L1.25391 4.6875M3.25391 1.6875H19.2539C20.3585 1.6875 21.2539 2.58293 21.2539 3.6875V15.6875C21.2539 16.7921 20.3585 17.6875 19.2539 17.6875H3.25391C2.14934 17.6875 1.25391 16.7921 1.25391 15.6875V3.6875C1.25391 2.58293 2.14934 1.6875 3.25391 1.6875Z",
    stroke: "#171717",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dfded2de6ffff538f6f187a19ebaf995.svg";
export { ForwardRef as ReactComponent };